import { useState, useEffect } from "react";

const TablePagination = ({
  page,
  allEntries,
  pages,
  setPage,
  size,
  setSize,
}) => {
  const [pageNumberLimit, setPageNumberLimit] = useState(3);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(3);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);

  const handleNextBtn = () => {
    setPage(page + 1);

    if (page + 2 > maxPageNumberLimit) {
      setMaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
      setMinPageNumberLimit(minPageNumberLimit + pageNumberLimit);
    }
  };

  const handlePageNumberClick = (e) => {
    setPage(Number(e.target.textContent - 1));
  };

  const handlePrevBtn = () => {
    setPage(page - 1);

    if (page % pageNumberLimit === 0) {
      setMaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
      setMinPageNumberLimit(minPageNumberLimit - pageNumberLimit);
    }
  };

  return (
    <div className="flex justify-between gap-2 items-center py-4 md:px-12">
      <div className="">
        <label htmlFor="pageSize" className="text-[#848484]">
          Page size
          <select
            className="pl-3 py-1.5 border-[#F4F4F4] mx-2 rounded-lg focus:outline-none bg-[#F4F4F4]"
            placeholder="5"
            onChange={(e) => {
              setSize(e.target.value);
            }}
          >
            {/* <option></option> */}
            <option value={size} disabled selected hidden>
              {size}
            </option>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </label>
      </div>

      <div>
        <p className=" text-xs hidden md:block text-[#848484]">
          Showing {page + 1} to {pages} of {allEntries} entries
        </p>
      </div>

      <div className="flex items-center justify-end">
        <button
          onClick={() => handlePrevBtn()}
          disabled={
            page + 1 === [...Array(Math.max(0, pages - 1))]?.length - pages + 2
              ? true
              : false
          }
          className="disabled:hover:bg-[#F4F4F4] disabled:cursor-not-allowed disabled:text-[#848484] bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-1 rounded text-sm hover:bg-[#FF6A3A] hover:text-white focus:bg-[#FF6A3A] focus:text-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        {[...Array(Math.max(0, pages))]?.map((value, index) => {
          if (
            index + 1 < maxPageNumberLimit + 1 &&
            index + 1 > minPageNumberLimit
          ) {
            return (
              <button
                key={index}
                type="button"
                onClick={(e) => handlePageNumberClick(e)}
                className={
                  page === index
                    ? " mx-1 py-1.5 px-3 rounded text-sm bg-[#FF6A3A] text-white"
                    : "bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-3 rounded text-sm hover:bg-[#FF6A3A] hover:text-white"
                }
              >
                {index + 1}
              </button>
            );
          }
        })}
        <button
          onClick={() => handleNextBtn()}
          disabled={
            page + 1 === [...Array(Math.max(0, pages))]?.length ? true : false
          }
          className="disabled:hover:bg-[#F4F4F4] disabled:cursor-not-allowed disabled:text-[#848484] bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-1 rounded text-sm hover:bg-[#FF6A3A] hover:text-white focus:bg-[#FF6A3A] focus:text-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default TablePagination;
